import { includes } from 'lodash';
import { toast } from 'react-toastify';

import { LoadingMessage } from 'components/common/General/LoadingMessage';
import { LinkableToastMessage } from 'components/common/LinkableToastMessage/LinkableToastMessage';
import { ignoredHttpErrorCodes } from 'components/HttpErrorBoundary/utils';
import { toastConfiguration } from 'components/utils/config';

export const toastError = (message: string, error?: any) => {
  if (includes(ignoredHttpErrorCodes, error?.response?.status)) return;

  toast.error(message, toastConfiguration());
};

export const toastSuccess = (message: string, duration?: number) => {
  toast.success(message, toastConfiguration(duration));
};

export const toastInfo = (message: string) => {
  toast.info(message, toastConfiguration());
};

export const toastLoading = (
  message: string,
): {
  toastId: string | number;
  dismiss: () => void;
} => {
  const toastId = toast.info(<LoadingMessage message={message} />, {
    autoClose: false,
    draggable: false,
    position: 'top-left',
    hideProgressBar: true,
  });

  return {
    toastId: toastId,
    dismiss: () => toast.dismiss(toastId),
  };
};

export const toastSuccessWithRedirection = (
  message: string,
  linkText: string,
  onClick: () => void,
): { toastId: string; dismiss: () => void } => {
  const toastId = message;

  toast.success(
    <LinkableToastMessage
      onClick={onClick}
      message={message}
      linkText={linkText}
    />,
    {
      autoClose: 10000,
      toastId: message,
      draggable: false,
      position: 'top-left',
    },
  );

  return {
    toastId: toastId,
    dismiss: () => toast.dismiss(toastId),
  };
};
